var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.headline)?_c('div',{staticClass:"custom-bg-hero-section"},[_c('div',{staticClass:"custom-bg-hero-section__container"},[_c('h1',{staticClass:"custom-bg-hero-section__headline"},[_vm._v("\n      "+_vm._s(_vm.headline)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"custom-bg-hero-section__subheadline",domProps:{"innerHTML":_vm._s(_vm.subheadline)}})]),_vm._v(" "),_c('pict',{attrs:{"block-name":"custom-bg-hero-section","default":{
      src: _vm.$options.image[_vm.$i18n.locale].l,
      srcset: {
        '2x': _vm.$options.image[_vm.$i18n.locale].l2x
      }
    },"alt":_vm.headline}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }